import type { TvWishWallTheme } from "../models/contracts";

export interface WishWallThemeDefinition {
  id: TvWishWallTheme;
  title: string;
  description: string;
  layout: "sparse" | "layered" | "featured" | "grid" | "mosaic" | "paper";
  visibleLimit: number;
  motion: "calm" | "drift" | "spotlight" | "settle";
  appearance: "glass" | "luminous" | "paper";
}

export const wishWallThemes: readonly WishWallThemeDefinition[] = [
  { id: "Minimal", title: "Minimal Notes", description: "Elegant notes with generous breathing room.", layout: "sparse", visibleLimit: 4, motion: "calm", appearance: "glass" },
  { id: "Floating", title: "Floating Cards", description: "Layered cards with a gentle, lively drift.", layout: "layered", visibleLimit: 6, motion: "drift", appearance: "luminous" },
  { id: "Spotlight", title: "Spotlight Wish", description: "One special wish with supporting messages.", layout: "featured", visibleLimit: 5, motion: "spotlight", appearance: "glass" },
  { id: "Grid", title: "Classic Grid", description: "A balanced, highly readable card wall.", layout: "grid", visibleLimit: 8, motion: "settle", appearance: "glass" },
  { id: "Mosaic", title: "Mosaic Flow", description: "An organized mix of card sizes and rhythm.", layout: "mosaic", visibleLimit: 5, motion: "settle", appearance: "luminous" },
  { id: "Polaroid", title: "Polaroid Wishes", description: "Warm, playful keepsake notes.", layout: "paper", visibleLimit: 6, motion: "calm", appearance: "paper" },
] as const;

export const normalizeWishWallTheme = (value?: TvWishWallTheme): TvWishWallTheme =>
  wishWallThemes.some(theme => theme.id === value) ? value! : "Minimal";

export const wishWallTheme = (value?: TvWishWallTheme): WishWallThemeDefinition =>
  wishWallThemes.find(theme => theme.id === normalizeWishWallTheme(value))!;
